export default {
  title: 'Terminal',
  stats: {
    terminal_battery_level: 'Batteriniveau',
    terminal_battery_state: 'Opladningsstatus',
    auto_accept_orders: 'Accepter ordrer automatisk',
  },
  auto_accept_orders_modal: {
    title: 'Er du sikker på, at du vil acceptere ordrer automatisk?',
    buttons: {
      activate: 'Aktiver',
      cancel: 'Annuller',
    },
  },
  feedback: {
    update_success: 'Opdateret',
    update_failed: 'Oplysningerne kunne ikke opdateres. Prøv igen.',
  },
};
